import { TFunction } from "react-i18next";

import { User } from "../models/user";
import { GenericSchema, UserFields } from "../types";
import { CompanyProfile } from "./enums";
import { isRetailerPlus } from "./validation";

export const userScheme = (
  t: TFunction<"translation", undefined>,
  newUser?: User,
  currentUser?: User
) => {
  const schemaObject: GenericSchema<UserFields> = (newUser) => ({
    name: newUser?.name,
    lastName: newUser?.lastName,
    phone: newUser?.phone,
    email: newUser?.email,
    isDateOfBirth: !!newUser?.dateOfBirth,
    dateOfBirth: newUser?.dateOfBirth,
    username: newUser?.username,
    typeUser: newUser?.typeUser,
    status: newUser?.status,
    code: newUser?.code,
    timezoneId: newUser?.timezoneId,
    roleId: newUser?.roleId,
    isFM: isRetailerPlus(newUser?.company ? newUser?.company : currentUser?.company),
    projects: newUser?.projects,
    isProfileMoving:
      currentUser?.company?.profile &&
      currentUser?.company?.profile?.initials === CompanyProfile.MV,
    branches: newUser?.branches,
  });

  return {
    genericObject: schemaObject,
  };
};
